import AOS from 'aos';
import { CountUp } from 'countup.js';

// Initialize AOS
AOS.init({
  duration: 700,
  easing: 'ease-out-quad',
  once: true,
  startEvent: 'load',
});

window.AOS = AOS;
window.CountUp = CountUp;
